class PurchaseInvoiceHistoryModel{
    purchaseInvoiceMainId:number;
    purchaseInvoiceLineId:number;
    productId:number;
    productCode:string;
    productName:string;
    orderDate?: string;
    deliveryDate?:string;
    grnNo?:string;
    grnDate?:string;
    orderQty:number;
    quantity:number;
    rate:number;
    cgstAmount:number;
    sgstAmount:number;
    igstAmount:number;
    netAmount?:string;
    invoiceNumber?:string;
    droppingPointId?:number;
    droppingPointName?:string;
    droppingPointCode?:string;
    unionId:number;
    sessionId?:number;
    sessionName?:string;
    purchaseInvoiceLineDetailsParsed?:[];
    orderDate2:Date;


    name?: string;
    counterName?:string;
    currentDate?:string;

    
    
}
export default PurchaseInvoiceHistoryModel;